"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _string_utils = _interopRequireDefault(require("./string_utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// https://github.com/geetarista/underscore.inflections/blob/master/lib/underscore.inflections.js
var _default = function () {
  var Inflector = /*#__PURE__*/function () {
    // Set up arrays and apply default rules
    function Inflector() {
      _classCallCheck(this, Inflector);

      this.applyDefaultRules = this.applyDefaultRules.bind(this);
      this.applyDefaultUncountables = this.applyDefaultUncountables.bind(this);
      this.applyDefaultPlurals = this.applyDefaultPlurals.bind(this);
      this.acronym = this.acronym.bind(this);
      this.plural = this.plural.bind(this);
      this.singular = this.singular.bind(this);
      this.irregular = this.irregular.bind(this);
      this.uncountable = this.uncountable.bind(this);
      this.human = this.human.bind(this);
      this.clearInflections = this.clearInflections.bind(this);
      this.pluralize = this.pluralize.bind(this);
      this.singularize = this.singularize.bind(this);
      this.notranslate_pluralize = this.notranslate_pluralize.bind(this);
      this.camelize = this.camelize.bind(this);
      this.underscore = this.underscore.bind(this);
      this.humanize = this.humanize.bind(this);
      this.titleize = this.titleize.bind(this);
      this.apply_inflections = this.apply_inflections.bind(this);
      this.plurals = [];
      this.singulars = [];
      this.uncountables = [];
      this.humans = [];
      this.acronyms = {};
      this.applyDefaultRules();
    } // Apply all default rules


    _createClass(Inflector, [{
      key: "applyDefaultRules",
      value: function applyDefaultRules() {
        this.applyDefaultUncountables();
        this.applyDefaultPlurals();
        this.applyDefaultSingulars();
        return this.applyDefaultIrregulars();
      } // Apply rules for list of uncountables

    }, {
      key: "applyDefaultUncountables",
      value: function applyDefaultUncountables() {
        return this.uncountable(this.defaultUncountables);
      } // Apply rules for list of default plurals

    }, {
      key: "applyDefaultPlurals",
      value: function applyDefaultPlurals() {
        var _this = this;

        return _underscore.default.each(this.defaultPluralRules, function (rule) {
          var _Array$from = Array.from(rule),
              _Array$from2 = _slicedToArray(_Array$from, 2),
              regex = _Array$from2[0],
              capture = _Array$from2[1];

          return _this.plural(regex, capture);
        });
      } // Apply rules for list of default singulars

    }, {
      key: "applyDefaultSingulars",
      value: function applyDefaultSingulars() {
        var _this2 = this;

        return _underscore.default.each(this.defaultSingularRules, function (rule) {
          var _Array$from3 = Array.from(rule),
              _Array$from4 = _slicedToArray(_Array$from3, 2),
              regex = _Array$from4[0],
              capture = _Array$from4[1];

          return _this2.singular(regex, capture);
        });
      } // Apply rules for list of default irregulars

    }, {
      key: "applyDefaultIrregulars",
      value: function applyDefaultIrregulars() {
        var _this3 = this;

        return _underscore.default.each(this.defaultIrregularRules, function (rule) {
          var _Array$from5 = Array.from(rule),
              _Array$from6 = _slicedToArray(_Array$from5, 2),
              singular = _Array$from6[0],
              plural = _Array$from6[1];

          return _this3.irregular(singular, plural);
        });
      }
    }, {
      key: "acronym",
      value: function acronym(word) {
        this.acronyms[word.toLowerCase()] = word;
        return this.acronym_matchers = _underscore.default.values(this.acronyms).join('|');
      } // Specifies a new pluralization rule and its replacement. The rule can either be a string or a regular expression.
      // The replacement should always be a string that may include references to the matched data from the rule.

    }, {
      key: "plural",
      value: function plural(rule, replacement) {
        if (typeof rule === 'string') {
          delete this.uncountables[_underscore.default.indexOf(this.uncountables, rule)];
        }

        delete this.uncountables[_underscore.default.indexOf(this.uncountables, replacement)];
        return this.plurals.unshift([rule, replacement]);
      } // Specifies a new singularization rule and its replacement. The rule can either be a string or a regular expression.
      // The replacement should always be a string that may include references to the matched data from the rule.

    }, {
      key: "singular",
      value: function singular(rule, replacement) {
        if (typeof rule === 'string') {
          delete this.uncountables[_underscore.default.indexOf(this.uncountables, rule)];
        }

        delete this.uncountables[_underscore.default.indexOf(this.uncountables, replacement)];
        return this.singulars.unshift([rule, replacement]);
      } // Specifies a new irregular that applies to both pluralization and singularization at the same time. This can only be used
      // for strings, not regular expressions. You simply pass the irregular in singular and plural form.
      //
      // Examples:
      //
      //     _.irregular('octopus', 'octopi')
      //     _.irregular('person', 'people')

    }, {
      key: "irregular",
      value: function irregular(singular, plural) {
        delete this.uncountables[_underscore.default.indexOf(this.uncountables, singular)];
        delete this.uncountables[_underscore.default.indexOf(this.uncountables, plural)];

        if (singular.substring(0, 1).toUpperCase() === plural.substring(0, 1).toUpperCase()) {
          this.plural(new RegExp("(".concat(singular.substring(0, 1), ")").concat(singular.substring(1, plural.length), "$"), 'i'), "$1".concat(plural.substring(1, plural.length)));
          this.plural(new RegExp("(".concat(plural.substring(0, 1), ")").concat(plural.substring(1, plural.length), "$"), 'i'), "$1".concat(plural.substring(1, plural.length)));
          return this.singular(new RegExp("(".concat(plural.substring(0, 1), ")").concat(plural.substring(1, plural.length), "$"), 'i'), "$1".concat(singular.substring(1, plural.length)));
        }

        this.plural(new RegExp("".concat(singular.substring(0, 1)).concat(singular.substring(1, plural.length), "$"), 'i'), plural.substring(0, 1) + plural.substring(1, plural.length));
        this.plural(new RegExp("".concat(singular.substring(0, 1)).concat(singular.substring(1, plural.length), "$"), 'i'), plural.substring(0, 1) + plural.substring(1, plural.length));
        this.plural(new RegExp("".concat(plural.substring(0, 1)).concat(plural.substring(1, plural.length), "$"), 'i'), plural.substring(0, 1) + plural.substring(1, plural.length));
        this.plural(new RegExp("".concat(plural.substring(0, 1)).concat(plural.substring(1, plural.length), "$"), 'i'), plural.substring(0, 1) + plural.substring(1, plural.length));
        this.singular(new RegExp("".concat(plural.substring(0, 1)).concat(plural.substring(1, plural.length), "$"), 'i'), singular.substring(0, 1) + singular.substring(1, plural.length));
        return this.singular(new RegExp("".concat(plural.substring(0, 1)).concat(plural.substring(1, plural.length), "$"), 'i'), singular.substring(0, 1) + singular.substring(1, plural.length));
      } // Add uncountable words that shouldn't be attempted inflected.
      //
      // Examples:
      //
      //     _.uncountable("money")
      //     _.uncountable("money", "information")
      //     _.uncountable(["money", "information", "rice"])

    }, {
      key: "uncountable",
      value: function uncountable() {
        for (var _len = arguments.length, words = new Array(_len), _key = 0; _key < _len; _key++) {
          words[_key] = arguments[_key];
        }

        this.uncountables.push(words);
        return this.uncountables = _underscore.default.flatten(this.uncountables);
      }
    }, {
      key: "human",
      value: function human(rule, replacement) {
        return this.humans.unshift([rule, replacement]);
      } // Clears the loaded inflections within a given scope (default is `'all'`).
      // Give the scope as a symbol of the inflection type, the options are: `'plurals'`,
      // `'singulars'`, `'uncountables'`, `'humans'`.
      //
      // Examples:
      //
      //     _.clearInflections('all')
      //     _.clearInflections('plurals')

    }, {
      key: "clearInflections",
      value: function clearInflections(scope) {
        if (scope == null) {
          scope = 'all';
        }

        return this[scope] = [];
      } // Pluralizes a word
      //
      // Examples:
      //
      //     _.pluralize('')

    }, {
      key: "pluralize",
      value: function pluralize(word, count, options) {
        if (options == null) {
          options = {};
        }

        options = _underscore.default.extend({
          plural: undefined,
          showNumber: true
        }, options);

        if (count !== undefined) {
          var result = '';

          if (options.showNumber === true) {
            result += "".concat(count != null ? count : 0, " ");
          }

          return result += count === 1 || __guardMethod__(count, 'toString', function (o) {
            return o.toString().match(/^1(\.0+)?$/);
          }) ? word : options.plural != null ? options.plural : this.pluralize(word);
        }

        return this.apply_inflections(word, this.plurals);
      } // Singularizes a word

    }, {
      key: "singularize",
      value: function singularize(word) {
        return this.apply_inflections(word, this.singulars);
      }
    }, {
      key: "notranslate_pluralize",
      value: function notranslate_pluralize(word, count) {
        if (count == null) {
          count = 0;
        }

        var result = "<var count pluralize='".concat(count, "'>").concat(count, "</var> ");
        var pword = count === 1 || __guardMethod__(count, 'toString', function (o) {
          return o.toString().match(/^1(\.0+)?$/);
        }) ? word : this.pluralize(word);
        return result + _string_utils.default.escapeHTML(pword);
      }
    }, {
      key: "camelize",
      value: function camelize(term, uppercase_first_letter) {
        var _this4 = this;

        if (uppercase_first_letter == null) {
          uppercase_first_letter = true;
        }

        if (uppercase_first_letter) {
          term = term.replace(/^[a-z\d]*/, function (a) {
            return _this4.acronyms[a] || _underscore.default.capitalize(a);
          });
        } else {
          term = term.replace(new RegExp("^(?:".concat(this.acronym_matchers, "(?=\\b|[A-Z_])|\\w)")), function (a) {
            return a.toLowerCase();
          });
        }

        return term = term.replace(/(?:_|(\/))([a-z\d]*)/gi, function (match, $1, $2, idx, string) {
          if (!$1) {
            $1 = '';
          }

          return "".concat($1).concat(_this4.acronyms[$2] || _underscore.default.capitalize($2));
        });
      }
    }, {
      key: "underscore",
      value: function underscore(camel_cased_word) {
        var word = camel_cased_word;
        word = word.replace(new RegExp("(?:([A-Za-z\\d])|^)(".concat(this.acronym_matchers, ")(?=\\b|[^a-z])"), 'g'), function (match, $1, $2) {
          return "".concat($1 || '').concat($1 ? '_' : '').concat($2.toLowerCase());
        });
        word = word.replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2');
        word = word.replace(/([a-z\d])([A-Z])/g, '$1_$2');
        word = word.replace('-', '_');
        return word = word.toLowerCase();
      }
    }, {
      key: "humanize",
      value: function humanize(lower_case_and_underscored_word) {
        var _this5 = this;

        var word = lower_case_and_underscored_word;

        for (var _i2 = 0, _Array$from7 = Array.from(this.humans); _i2 < _Array$from7.length; _i2++) {
          var human = _Array$from7[_i2];
          var rule = human[0];
          var replacement = human[1];

          if (rule.test != null && rule.test(word) || rule.indexOf != null && word.indexOf(rule) >= 0) {
            word = word.replace(rule, replacement);
            break;
          }
        }

        word = word.replace(/_id$/g, '');
        word = word.replace(/_/g, ' ');
        word = word.replace(/([a-z\d]*)/gi, function (match) {
          return _this5.acronyms[match] || match.toLowerCase();
        });
        return word = _underscore.default.trim(word).replace(/^\w/g, function (match) {
          return match.toUpperCase();
        });
      }
    }, {
      key: "titleize",
      value: function titleize(word) {
        return this.humanize(this.underscore(word)).replace(/([\s¿]+)([a-z])/g, function (match, boundary, letter, idx, string) {
          return match.replace(letter, letter.toUpperCase());
        });
      } // Apple rules to a given word. If the last word fo the string is uncountable,
      // just return it. Otherwise, make the replacement and return that.

    }, {
      key: "apply_inflections",
      value: function apply_inflections(word, rules) {
        if (!word) {
          return word;
        }

        var result = word;
        var match = result.toLowerCase().match(/\b\w+$/);

        if (match && _underscore.default.indexOf(this.uncountables, match[0]) !== -1) {
          return result;
        }

        for (var _i3 = 0, _Array$from8 = Array.from(rules); _i3 < _Array$from8.length; _i3++) {
          var rule = _Array$from8[_i3];

          var _Array$from9 = Array.from(rule),
              _Array$from10 = _slicedToArray(_Array$from9, 2),
              regex = _Array$from10[0],
              capture = _Array$from10[1];

          if (result.match(regex)) {
            result = result.replace(regex, capture);
            break;
          }
        }

        return result;
      }
    }], [{
      key: "initClass",
      value: function initClass() {
        // Common uncountable words
        this.prototype.defaultUncountables = ['equipment', 'information', 'rice', 'money', 'species', 'series', 'fish', 'sheep', 'jeans', 'moose', 'deer', 'news', 'music']; // Plural rules

        this.prototype.defaultPluralRules = [[/$/, 's'], [/s$/i, 's'], [/^(ax|test)is$/i, '$1es'], [/(octop|vir)us$/i, '$1i'], [/(octop|vir)i$/i, '$1i'], [/(alias|status)$/i, '$1es'], [/(bu)s$/i, '$1ses'], [/(buffal|tomat)o$/i, '$1oes'], [/([ti])um$/i, '$1a'], [/([ti])a$/i, '$1a'], [/sis$/i, 'ses'], [/(?:([^f])fe|([lr])f)$/i, '$1$2ves'], [/(hive)$/i, '$1s'], [/([^aeiouy]|qu)y$/i, '$1ies'], [/(x|ch|ss|sh)$/i, '$1es'], [/(matr|vert|ind)(?:ix|ex)$/i, '$1ices'], [/(m|l)ouse$/i, '$1ice'], [/(m|l)ice$/i, '$1ice'], [/^(ox)$/i, '$1en'], [/^(oxen)$/i, '$1'], [/(quiz)$/i, '$1zes']]; // Singular rules

        this.prototype.defaultSingularRules = [[/s$/i, ''], [/(ss)$/i, '$1'], [/(n)ews$/i, '$1ews'], [/([ti])a$/i, '$1um'], [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)(sis|ses)$/i, '$1$2sis'], [/(^analy)(sis|ses)$/i, '$1sis'], [/([^f])ves$/i, '$1fe'], [/(hive)s$/i, '$1'], [/(tive)s$/i, '$1'], [/([lr])ves$/i, '$1f'], [/([^aeiouy]|qu)ies$/i, '$1y'], [/(s)eries$/i, '$1eries'], [/(m)ovies$/i, '$1ovie'], [/(x|ch|ss|sh)es$/i, '$1'], [/(m|l)ice$/i, '$1ouse'], [/(bus)(es)?$/i, '$1'], [/(o)es$/i, '$1'], [/(shoe)s$/i, '$1'], [/(cris|test)(is|es)$/i, '$1is'], [/^(a)x[ie]s$/i, '$1xis'], [/(octop|vir)(us|i)$/i, '$1us'], [/(alias|status)(es)?$/i, '$1'], [/^(ox)en/i, '$1'], [/(vert|ind)ices$/i, '$1ex'], [/(matr)ices$/i, '$1ix'], [/(quiz)zes$/i, '$1'], [/(database)s$/i, '$1']]; // Irregular rules

        this.prototype.defaultIrregularRules = [['person', 'people'], ['man', 'men'], ['child', 'children'], ['sex', 'sexes'], ['move', 'moves'], ['cow', 'kine'], ['zombie', 'zombies']];
        this.prototype.defaultHumanRules = [];
      }
    }]);

    return Inflector;
  }();

  Inflector.initClass();
  return Inflector;
}();

exports.default = _default;

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== 'undefined' && obj !== null && typeof obj[methodName] === 'function') {
    return transform(obj, methodName);
  }

  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/utils/inflector.js
// module id = 316
// module chunks = 0 15 16 17 18